import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import React, { useContext } from "react";
import Slider from "react-slick";
import "../styles/style.css";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";

const images = ["hero_image_1.jpg", "hero_image_2.jpg"];

export const Hero = () => {
  const { language } = useContext(LanguageContext);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    fade: true,
  };

  return (
    <div className="hero-wrapper">
      <Slider {...settings}>
        {images.map((image, id) => (
          <img
            key={id}
            src={require(`../../../assets/images/${image}`)}
            alt="Serra da Estrela"
          />
        ))}
      </Slider>

      <div className="hero-overlay" />

      <div className="hero-content">
        <Typography
          className="hero-tagline"
          variant="body2"
          sx={{
            fontSize: isMobile ? "0.7rem" : "0.85rem",
            mb: 2,
          }}
        >
          {language === "pt"
            ? "Serra da Estrela \u00B7 Manteigas"
            : "Serra da Estrela \u00B7 Manteigas"}
        </Typography>

        <Typography
          className="hero-title"
          sx={{
            fontSize: isMobile ? "2.8rem" : "4.5rem",
            lineHeight: 1.1,
          }}
        >
          Casinhas do Mé-Mé
        </Typography>

        <div className="hero-divider" />

        <Typography
          className="hero-tagline"
          variant="body1"
          sx={{
            fontSize: isMobile ? "0.75rem" : "0.9rem",
            mb: 4,
            maxWidth: 500,
            letterSpacing: "0.15em !important",
          }}
        >
          {language === "pt"
            ? "Mais que um alojamento, uma vivência inigualável"
            : "More than just lodging, an unparalleled experience"}
        </Typography>

        <Box className="hero-cta">
          <Button
            href="accommodations"
            variant="contained"
            size={isMobile ? "medium" : "large"}
            sx={{
              px: isMobile ? 4 : 6,
              py: isMobile ? 1 : 1.5,
              borderRadius: 0,
              fontFamily: "'Lato', sans-serif",
              fontWeight: 400,
              letterSpacing: "0.15em",
              fontSize: isMobile ? "0.8rem" : "0.9rem",
              backgroundColor: "transparent",
              border: "1px solid var(--clr-primary-light)",
              color: "var(--clr-primary-light)",
              "&:hover": {
                backgroundColor: "var(--clr-primary)",
                borderColor: "var(--clr-primary)",
                color: "#fff",
              },
              transition: "all 0.4s ease",
            }}
          >
            {language === "pt" ? "Descubra" : "Discover"}
          </Button>
        </Box>
      </div>

      <div className="scroll-indicator" />
    </div>
  );
};
